export class ModelCurrentTaskIncidenceTotals {
  constructor(
    public finished: number,
    public scrapped: number,
    public recoverable: number,
    public totals: number
  ) { }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/summary/model-current-task-incidence-totals.ts